import React, { useRef, useEffect } from 'react'
import { ArrowUp, Hourglass } from 'lucide-react'

export default function ChatInput({ value, onChange, onSubmit, isLoading, disabled }) {
  const textareaRef = useRef(null)

  // Auto-resize textarea
  useEffect(() => {
    const el = textareaRef.current
    if (!el) return
    el.style.height = 'auto'
    el.style.height = Math.min(el.scrollHeight, 200) + 'px'
  }, [value])

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      if (!isLoading && value.trim()) onSubmit()
    }
  }

  const canSend = value.trim().length > 0 && !isLoading && !disabled

  return (
    <div style={{
      padding: '12px 16px 20px',
      background: 'var(--bg-main)',
    }}>
      <div style={{
        maxWidth: 760,
        margin: '0 auto',
        position: 'relative',
      }}>
        <div style={{
          background: 'var(--bg-input)',
          border: '1px solid var(--border)',
          borderRadius: '16px',
          display: 'flex',
          alignItems: 'flex-end',
          gap: '8px',
          padding: '12px 12px 12px 16px',
          transition: 'border-color var(--transition)',
          boxShadow: '0 0 0 0 transparent',
        }}
          onFocusCapture={e => e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)'}
          onBlurCapture={e => e.currentTarget.style.borderColor = 'var(--border)'}
        >
          <textarea
            ref={textareaRef}
            value={value}
            onChange={e => onChange(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Unesite pitanje za FMT GPS izveštaje"
            disabled={disabled}
            rows={1}
            style={{
              flex: 1,
              background: 'transparent',
              border: 'none',
              outline: 'none',
              color: 'var(--text-primary)',
              fontSize: 15,
              fontFamily: 'var(--font-sans)',
              lineHeight: 1.6,
              resize: 'none',
              maxHeight: '200px',
              overflowY: 'auto',
              paddingTop: 2,
            }}
          />

          {/* Send / Busy button */}
          <button
            onClick={isLoading ? undefined : onSubmit}
            disabled={!canSend && !isLoading}
            style={{
              width: 36,
              height: 36,
              borderRadius: '10px',
              background: canSend || isLoading ? 'var(--accent)' : 'rgba(255,255,255,0.06)',
              border: 'none',
              cursor: canSend ? 'pointer' : 'not-allowed',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              transition: 'background var(--transition)',
            }}
            onMouseEnter={e => { if (canSend || isLoading) e.currentTarget.style.background = 'var(--accent-hover)' }}
            onMouseLeave={e => { if (canSend || isLoading) e.currentTarget.style.background = 'var(--accent)' }}
          >
            {isLoading
              ? <Hourglass size={16} color="white" fill="white" />
              : <ArrowUp size={16} color={canSend ? 'white' : 'var(--text-muted)'} />
            }
          </button>
        </div>

        <p style={{
          textAlign: 'center',
          fontSize: 11,
          color: 'var(--text-muted)',
          marginTop: 8,
        }}>
          Shift+Enter za novu liniju
        </p>
      </div>
    </div>
  )
}
